import { Cell } from 'rsuite-table'
import { Button } from 'rsuite'

const ReadCell = ({ rowData, onReadClick, ...props }: any) => {
  return (
    <Cell {...props} style={{ textAlign: 'center' }}>
      <Button appearance="primary" onClick={() => onReadClick(rowData)}>
        Redo
      </Button>
    </Cell>
  )
}
export default ReadCell
